import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export const Container = styled.div`
  background-color: #f3f4f8;
  padding: 0 20px 20px 20px;
  width: 100%;
`;

export const ManagerContainer = styled.div`
  height: 80%;
  width: 49%;
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;

  @media screen and (max-width: 800px) {
    width: 100%;
    height: max-content;
    margin-bottom: 20px;
  }
`;

export const ManagerHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Header = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  padding-right: 16px;
  height: 60px;
`;

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  height: 100%;
  font-family: Biotif;
  width: max-content;
  font-size: 20px;
  font-weight: 600;
  border: none;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  background-color: #f3f4f8;
  * {
    margin-right: 8px;
  }
`;

export const ArrowBack = styled.img`
  height: 15px;
  width: auto;
`;

export const NavTextLink = styled(NavLink)`
  align-self: center;
  text-decoration: none;
  color: #222247;
`;
